import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import produce from 'immer';
import _get from 'lodash/get';
import _head from 'lodash/head';
import _join from 'lodash/join';
import _set from 'lodash/set';
import _noop from 'lodash/noop';
import _map from 'lodash/map';
import _forEach from 'lodash/forEach';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { NESTING_KEY_SEPERATOR } from '../constants/general';
export var getTableDataWithLastRowBoolean = function getTableDataWithLastRowBoolean(tableValues) {
  var tableValuesLength = tableValues.length;
  // add a check for other empty rows as well, but the tablerowdata can have some default values as well --> take a function from user may be
  return _map(tableValues, function (tableValue, index) {
    return index === tableValuesLength - 1 ? _objectSpread(_objectSpread({}, tableValue), {}, {
      isLastRow: true
    }) : _objectSpread(_objectSpread({}, tableValue), {}, {
      isLastRow: false
    });
  });
};
export var getSetCellData = function getSetCellData(callback) {
  return function (_ref) {
    var getState = _ref.getState,
      setState = _ref.setState,
      payload = _ref.params,
      extraStateUpdates = _ref.extraStateUpdates;
    var id = payload.id,
      value = payload.value,
      nestingPath = payload.nestingPath,
      columnId = payload.columnId;
    var currentTableValue = _get(getState(), "values.".concat(id));
    var newTableValues = updateCellInTableState({
      nestingPath: nestingPath,
      columnId: columnId,
      value: value,
      currentState: currentTableValue
    });
    updateTableInState({
      id: id,
      setState: setState,
      value: getTableDataWithLastRowBoolean(newTableValues),
      callback: callback,
      extraStateUpdates: extraStateUpdates
    });
  };
};
export var updateTableInState = function updateTableInState(_ref2) {
  var setState = _ref2.setState,
    id = _ref2.id,
    value = _ref2.value,
    _ref2$callback = _ref2.callback,
    callback = _ref2$callback === void 0 ? _noop : _ref2$callback,
    extraStateUpdates = _ref2.extraStateUpdates;
  setState(produce(function (currState) {
    _set(currState, "values.".concat(id), value);
    _forEach(extraStateUpdates, function (val, key) {
      _set(currState, key, val);
    });
  }), callback);
};

// updates an entire row
export var genericUpdateTableValueInState = function genericUpdateTableValueInState(currentFieldState, pathToBeUpdated, newRowData) {
  var newTableData = produce(currentFieldState, function (draftState) {
    _set(draftState, pathToBeUpdated, newRowData);
  });
  return getTableDataWithLastRowBoolean(newTableData);
};
export var updateCellInTableState = function updateCellInTableState(_ref3) {
  var nestingPath = _ref3.nestingPath,
    columnId = _ref3.columnId,
    value = _ref3.value,
    currentState = _ref3.currentState;
  return produce(currentState, function (draftState) {
    var objectLocationPath = getPathToBeUpdated(nestingPath);
    var objectToUpdate = _get(draftState, objectLocationPath);
    if (objectToUpdate) {
      objectToUpdate[columnId] = value;
    }
  });
};
export var getPathToBeUpdated = function getPathToBeUpdated(nestingPath) {
  if (nestingPath.length === 1) {
    return "".concat(_head(nestingPath));
  }
  return _join(nestingPath, NESTING_KEY_SEPERATOR);
};
export var getGeneralDetailsFromRowUpdateAction = function getGeneralDetailsFromRowUpdateAction(_ref4) {
  var getState = _ref4.getState,
    params = _ref4.params;
  var nestingPath = params.nestingPath,
    fieldId = params.id;
  var _getState = getState(),
    values = _getState.values;
  var pathToBeUpdated = _join(nestingPath, NESTING_KEY_SEPERATOR);
  var currentFieldState = _get(values, fieldId, EMPTY_OBJECT);
  var rowData = _get(currentFieldState, pathToBeUpdated, EMPTY_OBJECT);
  return {
    fieldId: fieldId,
    rowData: rowData,
    currentFieldState: currentFieldState,
    pathToBeUpdated: pathToBeUpdated
  };
};